import { Share } from '@mui/icons-material';
import { MenuItem, ListItemIcon, Typography } from '@mui/material';
import { useState } from 'react';

import { graphql, type DocumentType } from '@/gql';

import { env } from '@/env';

import { ShareArticleToNoticeboardDialog } from '../../dialogs/ShareArticleToNoticeboardDialog';

const SHARE_ARTICLE_TO_NOTICEBOARD_MENU_ITEM_ARTICLE_FRAGMENT = graphql(`
  fragment shareArticleToNoticeboardMenuItemArticleFields on Article {
    _id
    title
    link
    feed {
      _id
      name
      owner {
        ... on Group {
          _id
          machineName
        }
        ... on Service {
          _id
          machineName
        }
      }
    }
  }
`);

interface Props {
  article: DocumentType<
    typeof SHARE_ARTICLE_TO_NOTICEBOARD_MENU_ITEM_ARTICLE_FRAGMENT
  >;
  onClose: () => void;
}

export const ShareArticleToNoticeboardMenuItem = ({
  article,
  onClose,
}: Props) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const link = article?.feed?.owner?.machineName
    ? `${env.NEXT_PUBLIC_APP_URL}/s/${article?.feed?.owner?.machineName}/news/${article?._id}`
    : article?.link;

  return (
    <>
      <MenuItem
        onClick={() => {
          setDialogOpen(true);
          onClose();
        }}
      >
        <ListItemIcon>
          <Share />
        </ListItemIcon>
        <Typography variant="inherit">Share to noticeboard</Typography>
      </MenuItem>
      <ShareArticleToNoticeboardDialog
        title={article.title ?? ''}
        link={link || ''}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};
